export default "__VITE_ASSET__9ef58def__"